import { h, JSX } from 'preact'
import { bem } from '@nrk/dh-utils'

import styles from './Table.css'
import ieStyles from './Table-IE11.css'
import { ToggleButtonComponent } from '../../../shared/Toggle/ToggleButton'

const ieItem = ieStyles.table__item

function cell(index, ...modifiers) {
  return bem(styles.table__cell, ...modifiers) + ' ' + ieItem
}

function Unfocus(props: JSX.HTMLAttributes) {
  return h('dh-unfocus', { ...props })
}

interface TableProps extends JSX.HTMLAttributes {
  modifiers: {
    hasMore: boolean
    hasAntall?: boolean
    showAntall?: boolean
    isLimited?: boolean
  }
}

export function Table({ modifiers, children, ...rest }: TableProps) {
  return (
    <Unfocus class={bem(styles.table, modifiers)} {...rest}>
      {children}
    </Unfocus>
  )
}

interface TableHeaderCellProps extends JSX.HTMLAttributes {
  modifier: 'parti' | 'bar' | 'oppslutning' | 'antall'
  index: number
}

export function TableHeaderCell({ index, modifier, children, ...rest }: TableHeaderCellProps) {
  return (
    <div class={cell(index, modifier, 'header')} aria-hidden="true" {...rest}>
      {children}
    </div>
  )
}

interface TableCellProps extends JSX.HTMLAttributes {
  modifiers: Array<'parti' | 'bar' | 'bar-marker' | 'oppslutning' | 'antall'>
  isHidden?: boolean
  index: number
}

export function TableCell({ children, isHidden, index, modifiers, ...rest }: TableCellProps) {
  return (
    <div class={cell(index, ...modifiers, { more: isHidden })} {...rest} data-index={index}>
      {children}
    </div>
  )
}

interface TableFooterProps extends JSX.HTMLAttributes {
  smallScreensOnly?: boolean
}

export function TableFooter({ children, smallScreensOnly, ...rest }: TableFooterProps) {
  const classes = [styles.table__footer, smallScreensOnly && styles.table__footerSmallScreensOnly]
    .filter(Boolean)
    .join(' ')

  return (
    <div class={classes} {...rest}>
      {children}
    </div>
  )
}

interface TableFooterButtonProps extends JSX.HTMLAttributes {
  smallScreensOnly?: boolean
}

interface TableFooterExpandedButtonProps extends TableFooterButtonProps {
  selector: string
  classToToggle: string
  classWhenToggling?: string
  isCustomElementDisabled?: boolean
}

export function TableFooterToggleButton(props: TableFooterExpandedButtonProps) {
  const { children, smallScreensOnly, ...rest } = props

  const classes = [
    'nrk-button',
    styles.table__footerButton,
    smallScreensOnly && styles.table__footerButtonSmallScreensOnly
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <ToggleButtonComponent class={classes} {...rest}>
      {children}
    </ToggleButtonComponent>
  )
}
